module.exports = __webpack_public_path__ + "img/Manana1.f078baa4.jpg";